import { useNavigate, useLocation } from "react-router-dom";

/**
 * Drop-in replacement for useNavigate that preserves current search params (e.g. ?slug=).
 * Supports numeric (go back), string paths, and { pathname, search } objects.
 * Own query params in the destination path take precedence over current ones.
 */
const useNav = () => {
    const navigate = useNavigate();
    const { search } = useLocation();

    return (to, options) => {
        if (typeof to === "number") return navigate(to);

        const [pathname, ownQuery] =
            typeof to === "string"
                ? to.split("?")
                : [to.pathname, to.search?.replace(/^\?/, "")];

        const merged = new URLSearchParams(search);
        if (ownQuery) {
            new URLSearchParams(ownQuery).forEach((v, k) => merged.set(k, v));
        }

        const mergedSearch = merged.toString() ? "?" + merged.toString() : "";
        return navigate({ pathname, search: mergedSearch }, options);
    };
};

export default useNav;